module.exports = __webpack_public_path__ + "img/avatar-76.bcccc93f.png";